var Redux = require('redux');
var educationReducer = require('./education/reducers/education');
var activeBodyPartsReducer = require('./education/reducers/activeBodyParts');
var bodyPartReducer = require('./education/reducers/bodyPart');
var symptomReducer = require('./education/reducers/symptom');
var toolboxReducer = require('./education/reducers/toolbox');
var diseaseReducer = require('./education/reducers/disease');
var conditionsReducer = require('./conditions/reducers/conditions');
var selectedConditionReducer = require('./conditions/reducers/selectedCondition');
var activeConditionReducer = require('./conditions/reducers/activeCondition');
var activeInterventionReducer = require('./conditions/reducers/activeIntervention');
var featuredPlacementReducer = require('./conditions/reducers/featuredPlacement');
var sponsoredPlacementReducer = require('./conditions/reducers/sponsoredPlacement');
var activeEducationToggleReducer = require('./education/reducers/activeEducationToggle');
var authReducer = require('./auth/reducers/auth');
var newsletterReducer = require('./newsletter/reducers/newsletter');
var passwordReducer = require('./password/reducers/password');
var routerReducer = require('react-router-redux').routerReducer;
var messageReducer = require('./message-center/reducers/message');
var messagesReducer = require('./message-center/reducers/messages');
var tagsReducer = require('./tags/reducers/tags');
var targetsReducer = require('./targets/reducers/targets');
var profileReducer = require('./profile/reducers/profile');
var commonReducer = require('./common/reducers/common');
var facebookLikeModalReducer = require('./facebook-like-modal/reducers/facebook-like-modal');
var contactReducer = require('./contact/reducers/contact');
var contentListReducer = require('./content/reducers/contentList');
var surveyReducer = require('./survey/reducers/surveys');
var responseReducer = require('./responses/reducers/responses');
var entities = require('./entities');
var surveyStateHistoryReducer = require('./surveyStateHistory/reducers/surveyStateHistory');
var latestScoreReducer = require('./latestScore/reducers/latestScore');
var modalReducer = require('./modals/reducers/modal');
var dashboardReducer = require('./dashboard/reducers/dashboard');
var specialistsReducer = require('./specialists/reducers/specialists');
var specialistReducer = require('./specialists/reducers/specialist');
var postReducer = require('./posts/reducers/post');
var postListReducer = require('./posts/reducers/postList');
var practiceReducer = require('./practice/reducers/practice');
var trialsReducer = require('./trials/reducers/trials');

const appReducer = Redux.combineReducers({
    education: educationReducer,
    conditions: conditionsReducer,
    activeBodyParts: activeBodyPartsReducer,
    bodyPart: bodyPartReducer,
    symptom: symptomReducer,
    toolbox: toolboxReducer,
    disease: diseaseReducer,
    selectedCondition: selectedConditionReducer,
    activeCondition: activeConditionReducer,
    activeIntervention: activeInterventionReducer,
    featuredPlacement: featuredPlacementReducer,
    sponsoredPlacement: sponsoredPlacementReducer,
    activeEducationToggle: activeEducationToggleReducer,
    auth: authReducer,
    newsletter: newsletterReducer,
    password: passwordReducer,
    routing: routerReducer,
    message: messageReducer,
    messages: messagesReducer,
    tags: tagsReducer,
    targets: targetsReducer,
    profile: profileReducer,
    common: commonReducer,
    showFacebookLikeModal: facebookLikeModalReducer,
    contact: contactReducer,
    contentList: contentListReducer,
    entities: entities,
    surveys: surveyReducer,
    responses: responseReducer,
    surveyStateHistory: surveyStateHistoryReducer,
    latestScore: latestScoreReducer,
    modal: modalReducer,
    dashboard: dashboardReducer,
    specialists: specialistsReducer,
    specialist: specialistReducer,
    post: postReducer,
    postList: postListReducer,
    practice: practiceReducer,
    trials: trialsReducer,
});

const rootReducer = function (state, action) {
    if (action.type === 'AUTH_LOGOUT') {
        state.auth = undefined;
        state.profile = undefined;
        state.latestScore = undefined;
        state.specialist = undefined;
        state.specialists = undefined;
        state.education.thanksRegisteringMessage = '';
    }

    if (action.type === 'CLEAR_PREVIOUS_STATE') {
        state.responses = undefined;
        state.entities = undefined;
        state.surveys = undefined;
        state.surveyStateHistory = undefined;
    }

    return appReducer(state, action)
}

module.exports = rootReducer;



// WEBPACK FOOTER //
// ./src/common/modules/reducers.js